function heroSlider($) {
    $('.hero-slide-module__slider').slick({
        infinite: true,
        arrows: true,
        dots: true,
        fade: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        prevArrow: $('.hero-slide-module__arrow--prev'),
        nextArrow: $('.hero-slide-module__arrow--next'),
        appendDots: $('.hero-slide-module__dots'),
        autoplay: true,
    });
}

// Inits
if (typeof jQuery !== 'undefined') {
    jQuery(function ($) {
        heroSlider($);
    });
}